import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_DAPIAN_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_092',
        name: '引航',
        genre: 'movie',
        synopsis: '西南峡谷山体滑坡形成堰塞湖，威胁上游安全。运输航空兵某团奉命开辟高原峡谷航线，空投定向爆破，配合地面工程队开挖泄洪槽。机长郑苍海带教新领航员沈滟，第三飞遭遇谷口横风超限，沈滟拿出被航校否掉的备用航法带队穿谷，爆破与开挖如期对接，泄洪槽成功贯通。',
        roles: [
            {
                name: '郑苍海',
                roleType: '男主角',
                billing: 1,
                intro: '运输机机长，高原航线飞了十四年。飞行稳，话少，带教新领航员从不放水。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '沈滟',
                roleType: '女配角',
                billing: 2,
                intro: '新任领航员，航校毕业。毕业时写下的峡谷备用航法被答辩组否掉，这次抢险派上了用场。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '雷冬子',
                roleType: '男配角',
                billing: 3,
                intro: '空降列兵，第一次执行实投任务，跳伞动作是全连标兵。上机前话多，落地后不吭声。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, stamina: 2, charm: 2 },
            },
            {
                name: '周晓露',
                roleType: '女配角',
                billing: 4,
                intro: '随队卫生员，负责排雷作业期间的健康监测。排雷那阵她天天背着药箱站在警戒线外，路清通那天她是头一个跑上山道的人。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'charm', value: 15 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Disaster, ScriptTheme.SeriousDrama, ScriptTheme.Action],
        heat: 46,
        baseScore: 8.0,
    },
    {
        id: 'SCRIPT_093',
        name: '地锚',
        genre: 'movie',
        synopsis: '2089年，太阳风暴扯断了地月货运索道，四百公里的锁链脱了轨，将在九十天后砸进太平洋。全国工程局轮班抢修，老检修工白重山与在轨配重工程师庄聆负责排险。第八十一天，锁链第七节的焊缝暴露出伪造的巡检签名，指向一个早已退役的人，抢险与追责同时收口。',
        roles: [
            {
                name: '庄聆',
                roleType: '女主角',
                billing: 1,
                intro: '航天局在轨配重工程师。早前算出过索道断裂的落点，没人信，这次配重由她全权负责。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '鲁照野',
                roleType: '男二号',
                billing: 2,
                intro: '抢修队最年轻的索工，在失重舱里长到十岁才回地面。出事的第七节锁链归他巡检。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'charm', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 2, stamina: 2, charm: 2 },
            },
            {
                name: '佟丽',
                roleType: '女配角',
                billing: 4,
                intro: '地面控制中心的物资调度主管，专管救援物资的优先级排序。她手里那张清单每改一次，发射窗口就推一天。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'wisdom', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Disaster, ScriptTheme.SeriousDrama],
        heat: 51,
        baseScore: 8.2,
    },
    {
        id: 'SCRIPT_094',
        name: '风暴眼',
        genre: 'movie',
        synopsis: '超级台风正面登陆东南沿海，港口城市启动一级响应。海上救援队、电网抢修班、危化品处置组三线同时展开，在台风登陆前夜将两千名被困游客全部安全转移。风停后全城恢复供电，指挥中心大屏打出庆功标语，赞誉与质疑一起到来。',
        roles: [
            {
                name: '滕跃',
                roleType: '男主角',
                billing: 1,
                intro: '海上救援队队长，体能全队第一，逆风开船救人是他的招牌。口头禅是"专业的事交给专业的人"。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '常欣慰',
                roleType: '女主角',
                billing: 1,
                intro: '市气象台首席预报员，提前精准预测出台风路径。发布会上她的预报图表赢得全场鼓掌。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Disaster, ScriptTheme.Action],
        heat: 37,
        baseScore: 6.1,
    },
    {
        id: 'SCRIPT_107',  // 低分反面教材·电影/低分电影
        name: '鸣沙引',
        genre: 'movie',
        synopsis: '西域有古国曰鸣沙，其民以声为图腾：言语出口凝作沙粒，历代沙粒积垒成王国城墙。定弦师商声因一曲禁音获罪流放出城，回声族最后的巫女闻蝉被作为「实证」锁进王都。新王飞庚命二人重铸「王音」，打开沙海下的古城，夺取上代大祭司留下的城基之力；老祭司无射则欲借此行撼动国本。古城门将启之夜，商声才知道闻蝉身上藏着的那个秘密，足以倾覆包括他在内的整个王国。',
        roles: [
            {
                name: '商声',
                roleType: '男主角',
                billing: 1,
                intro: '定弦师，能听出天下任何一件乐器差的那一弦，因一记禁音获罪，流放路上只剩半截残琴。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, stamina: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '闻蝉',
                roleType: '女主角',
                billing: 1,
                intro: '回声族末代巫女，山中长大，开口说话时沙丘会跟着微微发响。她对王都的全部认知，来自一部三百年前的乐谱。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2, talent: 2 },
            },
            {
                name: '飞庚',
                roleType: '男二号',
                billing: 2,
                intro: '鸣沙新王，一场乐石之役夺位，王座底下压着历代国王的乐谱，他要打开沙海下那座古城。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 3, temperament: 3, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Fantasy, ScriptTheme.Romance],
        heat: 23,
        baseScore: 3.5,
    },
    {
        id: 'SCRIPT_109',  // 低分反面教材·电影/低分电影
        name: '天枢陷落',
        genre: 'movie',
        synopsis: '太阳活动骤变，月球科考站"天枢"与地面失联，护盾受损，月夜将在七十二小时内吞没全站。总工程师阮明云拒签撤离令留守，守护最后一组实验样本；试飞员林楚屿违规驾驶崭新的月运飞船赴月救援——从发射塔架的倒塌到月背的静默，再到天枢站最后一盏灯。七年未见的两人，救援的往返窗口只有十二小时。灯火一盏盏熄灭，他们在月壤上签下人类走出摇篮的答卷。',
        roles: [
            {
                name: '阮明云',
                roleType: '女主角',
                billing: 1,
                intro: '天枢站总工程师，驻月四年，值班日志的字越写越潦草，标定数据的小数位一位没错过。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'charm', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { temperament: 3, wisdom: 3, charm: 2, talent: 2 },
            },
            {
                name: '林楚屿',
                roleType: '男主角',
                billing: 1,
                intro: '试飞员，驾驶新造月运飞船强行起飞，地面最后一条指令是"返航"，他伸手合上了发报键。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, stamina: 3, wisdom: 2, talent: 2 },
            },
            {
                name: '郁雪岑',
                roleType: '女配角',
                billing: 5,
                intro: '天枢站通信舱的值机员，每天把中继天线掰向地球方向，把下一班货运飞船的窗口抄在舷窗边的值班表上。',
                level: 3,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Disaster, ScriptTheme.Romance],
        heat: 21,
        baseScore: 3.1,
    },
    {
        id: 'SCRIPT_123',
        name: '山海归墟',
        genre: 'movie',
        synopsis: '大水围城第三年，方士世家传人洛重明押送最后一只铜鼎入城，掌祭闻人晦宣布沉鼎入海、以活人合祭——洛重明的父亲三十年前正是这样沉的海。铜鼎运抵海边那天，滩涂上露出成排旧船骨。沉鼎还是治水，摆在所有人面前。',
        roles: [
            {
                name: '洛重明',
                roleType: '男主角',
                billing: 1,
                intro: '方士世家末子，自称会铸鼎不会治水。父亲三十年前沉的海，家里如今只剩他押送的这一只鼎。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'stamina', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, stamina: 3, temperament: 3, charm: 3 },
            },
            {
                name: '庄聿',
                roleType: '女主角',
                billing: 1,
                intro: '北军派来督押的参军，学的是兵，管的是三百刑徒。把押送队伍走成了行军，途中有人染病，她翻药方翻得比医官还熟。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, stamina: 2, wisdom: 2 },
            },
            {
                name: '沈葭',
                roleType: '女配角',
                billing: 3,
                intro: '河口工师，家三代在堤上筑堰。滩涂船骨露出来那晚，她第一个认出那不是沉船，是当年没入海的那批鼎。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'stamina', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, temperament: 2, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Fantasy, ScriptTheme.Action],
        heat: 50,
        baseScore: 7.8,
    },
    {
        id: 'SCRIPT_124',
        name: '收灯人',
        genre: 'movie',
        synopsis: '老城拆迁前夜，皮影班末代传人谈小灯失踪，只留下整箱影人和一出没有戏本的皮影戏《收灯令》。哥哥谈禾生回城寻弟，发现这出戏每演到哪儿，老城就真的熄一片灯。他循着唱腔锣鼓点与台口刻痕一路找到烽火台遗址，幕布后面多了一副没人认领的挑线杆。',
        roles: [
            {
                name: '谈禾生',
                roleType: '男主角',
                billing: 1,
                intro: '货运司机，离家八年，回城时弟弟已失踪九天。不懂皮影，但弟弟小时候记台词全靠他念。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '谈小灯',
                roleType: '男二号',
                billing: 2,
                intro: '皮影传人，一手"收灯"绝活只演给深夜的空街。失踪前最后一段唱腔，锣鼓点每次短半拍。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'artistry', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, artistry: 3, temperament: 2 },
            },
            {
                name: '拓跋燎',
                roleType: '男配角',
                billing: 3,
                intro: '《收灯令》里的边关守将。戏文唱他封城护灯，幕布上他却把灯油一桶桶运出城。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'temperament', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 2, stamina: 2, temperament: 2 },
            },
            {
                name: '宣绘',
                roleType: '女配角',
                billing: 3,
                intro: '非遗中心研究员，为拆迁区做皮影档案登记。唯一发现《收灯令》没有戏本、唱词全靠现场改的人。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'talent', value: 35 },
                    { attr: 'wisdom', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, talent: 2, wisdom: 2 },
            },
            {
                name: '温巧',
                roleType: '女配角',
                billing: 4,
                intro: '皮影班的挑线手，谈小灯失踪前最后一个搭过戏的人。她手里的挑线杆比别人短一截，是照着谈小灯的手改的。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'artistry', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { artistry: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Fantasy, ScriptTheme.Mystery, ScriptTheme.Culture],
        heat: 41,
        baseScore: 7.1,
    },
    {
        id: 'SCRIPT_127',
        name: '九霄阙',
        genre: 'movie',
        synopsis: '天界崩塌，十二枚星核流散人间。散修云彻为寻幼妹踏上寻核路，一路救下落难公主与魔族质子，集齐星核决战九霄阙，觉醒神族血脉一剑开天，公主补天泪化星雨。',
        roles: [
            {
                name: '云彻',
                roleType: '男主角',
                billing: 1,
                intro: '散修，身世成谜，觉醒神族血脉后实力飞跃。为寻幼妹踏上寻核路，路上的同伴越聚越多，寻妹的事，他提得越来越少。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, stamina: 3, temperament: 2, talent: 2 },
            },
            {
                name: '昭阳公主',
                roleType: '女主角',
                billing: 1,
                intro: '天界公主，奉旨出征寻核，中途遇险落难。法器是一面宝镜，被照到的人都会讲起自己的来历。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'talent', value: 50 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2, stamina: 2 },
            },
            {
                name: '桑落',
                roleType: '女二号',
                billing: 2,
                intro: '寻核路上结伴的剑修，师父死在第一枚星核落地的夜里。她说自己只是顺路，剑却始终走在云彻前面半步。',
                level: 5,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 40 },
                    { attr: 'temperament', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 4,
                attributeGrowth: { charm: 2, temperament: 2, talent: 2 },
            },
            {
                name: '莫回头',
                roleType: '男配角',
                billing: 3,
                intro: '魔族质子，军中的开心果。牺牲前留下一句遗言，战友们回过神时，他已经不在了。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 30 },
                    { attr: 'charm', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Fantasy, ScriptTheme.Action],
        heat: 20,
        baseScore: 3.2,
    },
    {
        id: 'SCRIPT_132',  // 世界级票房大片·版本一
        name: '昆仑阙',
        genre: 'movie',
        synopsis: '昆仑结界将崩，仙界灵气日渐枯竭，凡间妖气横溢。残存的仙族修士楚行徽携一枚千年玉珏逃亡凡间，誓要在结界彻底坍塌前修复封印。同行者是暗中守护结界根基的补阙师沈砚白，他手里握着一份记录了三千年封印历史的残卷。与此同时，主张毁灭旧秩序的仙界首席弟子贺云归率领大军追击而来，他认为不破不立，唯有打破封印才是新生之路。而沈砚白的亡师遗骨中，藏着修复封印的真正密钥。',
        roles: [
            {
                name: '楚行徽',
                roleType: '女主角',
                billing: 1,
                intro: '陨仙谷最后的传人，一剑可断十丈江水，如今灵力只剩三成。她携带的玉珏是师父临终前塞给她的，上面刻着她看不懂的古篆。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 100 },
                    { attr: 'stamina', value: 90 },
                    { attr: 'temperament', value: 80 },
                    { attr: 'talent', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 5, stamina: 4, temperament: 4, talent: 3 },
            },
            {
                name: '沈砚白',
                roleType: '男配角',
                billing: 2,
                intro: '结界根基一脉的末代补阙师，常年一件灰袍，手上全是茧子和烫痕。没人知道他其实一直在修补结界最核心的裂隙，修补的方式是一种失传已久的上古补天残术。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '贺云归',
                roleType: '男配角',
                billing: 3,
                intro: '仙界首席弟子，天才型剑修，主张彻底粉碎封印让所有人都能修道。他追杀楚行徽不是为了权力，是因为他真的相信旧秩序必须在毁灭中重生。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'stamina', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, stamina: 3, temperament: 2 },
            },
            {
                name: '苍梧',
                roleType: '男配角',
                billing: 3,
                intro: '隐居山林的剑客，楚行徽父亲的旧友。出场时已在柴房里坐化，坐姿笔直、手边一堆数到一半的柴火，被唤醒后只留一句遗言，说完便不再睁眼。',
                level: 5,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 40 },
                    { attr: 'stamina', value: 35 },
                    { attr: 'talent', value: 30 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 2, stamina: 2, talent: 2 },
            },
            {
                name: '玄鸢',
                roleType: '女配角',
                billing: 4,
                intro: '贺云归麾下的女将军，出身妖族，因战乱与仙族结盟。她对贺云归的疯狂计划心存疑虑，却在战场上一次次不得不站在他那边。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'stamina', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 3, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Ancient, ScriptTheme.Xianxia, ScriptTheme.Fantasy],
        heat: 52,
        baseScore: 7.4,
    },
    {
        id: 'SCRIPT_133',  // 世界级票房大片·版本二
        name: '潮起时',
        genre: 'movie',
        synopsis: '博物馆策展人姜昀被困在同一天里：每天凌晨五点，她会收到一条来自已故男友陆远的短信。循环久了她发现，每一轮的细节都不完全一样，像是有人在替她改时间——同一个时刻的天光，一次比一次暗。线索指向地下项目"溯时"，负责人是陆远生前的师兄陈远岫；项目里唯一记得所有循环的孟雨桐，从头到尾没解释过为什么。',
        roles: [
            {
                name: '姜昀',
                roleType: '女主角',
                billing: 1,
                intro: '国家博物馆策展人，擅长古代钟表修复。被困在循环中的一百多遍里，她已经背下了这条街上每一个摊贩的名字和营业时间。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '孟雨桐',
                roleType: '女二号',
                billing: 2,
                intro: '量子物理学研究者，"溯时"项目的参与者之一，兜里揣着一份逐日天光测值。她在循环中是唯一保留记忆的人，却从不解释为什么。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '陈远岫',
                roleType: '男配角',
                billing: 3,
                intro: '"溯时"项目负责人，实验日志的扉页夹着一张妻子的CT片。最初只是想留住逝去的人，失控之后他每天把循环参数往回收一点，一点也不敢收到底。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '陆远',
                roleType: '男配角',
                billing: 4,
                intro: '姜昀的未婚夫，出事一年零三个月。他只出现在回忆和循环生成的幻影里，短信永远是从前那句"今天也等你回家"，多出来的半句每轮都不一样，谁也分不清那是谁替他打的字。',
                level: 4,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 3, talent: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Romance, ScriptTheme.Mystery],
        heat: 56,
        baseScore: 7.8,
    },
    {
        id: 'SCRIPT_134',  // 世界级票房大片·版本三
        name: '永夜航路',
        genre: 'movie',
        synopsis: '世代飞船"远航号"离开地球已有七十年，船员们世代航行在前往半人马座的路上。然而中层工程师方若谷在检修引擎时发现了真相：飞船早在二十年前就已抵达目的地。谎是上一任船长撒的，宋景年接任后没有戳破，反而伪造了整艘船的导航系统，把这个谎补成一场笼罩全船的虚拟现实。方若谷决定联合底层劳工发起反抗，揭开这个维持了几十年的巨大谎言。',
        roles: [
            {
                name: '方若谷',
                roleType: '女主角',
                billing: 1,
                intro: '"远航号"引擎区的维修技师，靠拆解废弃零件自学工程学。她在下层贫民窟长大，深知飞船资源的分配有多么不公。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '宋景年',
                roleType: '男配角',
                billing: 2,
                intro: '船长，飞船权力的绝对核心。谎不是他编的，是他从老船长手里接过来的，接手那年他二十九，第一件事就是把导航数据改了个底朝天。他的理念是"哪怕生活在谎言中，只要能活下去就好"。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '陈叙',
                roleType: '女配角',
                billing: 3,
                intro: '副船长，协助宋景年维持虚拟现实的运转。她在一次例行巡检中偶然看到了真实的星空，从此陷入深深的矛盾。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '诺拉',
                roleType: '女配角',
                billing: 4,
                intro: '在船上出生的第三代，船员名册传到她这一代只剩下名字，姓早就不用了。她从未接触过外界，飞船的虚拟花园就是整个童年，也因此最早察觉这个世界不对劲。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 30 },
                    { attr: 'temperament', value: 25 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Mystery, ScriptTheme.Action],
        heat: 56,
        baseScore: 8.2,
    },
    {
        id: 'SCRIPT_135',  // 世界级票房大片·版本四
        name: '塔兰迪姆',
        genre: 'movie',
        synopsis: '塔兰迪姆是一座永不沉睡的完美之城，市民每天醒来都会自动清除前一天全部的记忆，从而始终保持快乐无忧的生活。档案馆管理员唐念真某天在自己的手机上发现了一张不属于今天拍摄的照片——照片拍于城市禁区，那里根本不是官方所说的荒芜废土。紧接着她听到了一段自己的语音留言："别相信他们说的任何事。"但她完全不记得自己录过这段话。',
        roles: [
            {
                name: '唐念真',
                roleType: '女主角',
                billing: 1,
                intro: '城市档案馆的普通管理员，日常工作是销毁一切"不应该存在的历史档案"。她没有想过自己为什么对这些档案如此执着。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '卢卡斯',
                roleType: '男配角',
                billing: 2,
                intro: '自由调查记者，专门搜集官方不愿公开的真相。找到唐念真是因为那张照片拍到了他正在调查的禁区核心地带。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2, charm: 2 },
            },
            {
                name: '米拉',
                roleType: '女配角',
                billing: 3,
                intro: '唐念真的同事兼室友，两人共事了八年。她对唐念真最近的发现似乎一无所知——或者她什么都知道却选择不说。',
                level: 4,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 30 },
                    { attr: 'talent', value: 25 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 2 },
            },
            {
                name: '小柜',
                roleType: '男配角',
                billing: 5,
                intro: '档案馆的抄件员，名字取自他常年抱着的资料柜编号。他以为这只是份轻松的差事，直到他抄到一页不该存在的档案。',
                level: 2,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 12 },
                ],
                shootWeeks: 1,
                attributeGrowth: { charm: 3 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Mystery],
        heat: 55,
        baseScore: 7.6,
    },
    {
        id: 'SCRIPT_136',  // 世界级票房大片·版本五
        name: '无声地带',
        genre: 'movie',
        synopsis: '近未来东南亚有一座漂浮在城市边缘的海上城，地下非法赛车联赛在这里蓬勃发展。职业车手程飞羽的父亲死于一场被篡改了数据的比赛，肇事车手逍遥法外。为了查明真相并为父报仇，她必须参加那场被称为"死亡跑道"的终极赛事，奖金足以买通任何人，代价是一旦失败便永无翻身之日。',
        roles: [
            {
                name: '程飞羽',
                roleType: '女主角',
                billing: 1,
                intro: '码头区出身的天才车手，擅长改装车和精准走位。父亲教了她所有的本事，她接手的赛车永远是车队里最破旧的那一辆。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'charm', value: 80 },
                    { attr: 'stamina', value: 70 },
                    { attr: 'talent', value: 65 },
                    { attr: 'temperament', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { charm: 4, stamina: 3, talent: 3, temperament: 3 },
            },
            {
                name: '梁骁',
                roleType: '男配角',
                billing: 2,
                intro: '卫冕冠军兼肇事者背后的金主，对胜利的执念源于童年在码头区被人看不起的日子。他用赛道上的奖杯证明了所有看不起他的人。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 3, talent: 3, stamina: 2 },
            },
            {
                name: '阿Ken',
                roleType: '男配角',
                billing: 3,
                intro: '车队里的年轻技师，天赋极高但缺乏纪律。他把程飞羽当作姐姐一般崇拜，也把她的事看得比命还重。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2 },
            },
            {
                name: '肥仔',
                roleType: '男配角',
                billing: 5,
                intro: '车队加油站的杂工，帮程飞羽搬零件、擦车身，梦想有朝一日能坐进副驾驶。',
                level: 3,
                gender: 'male',
                requirements: [
                    { attr: 'temperament', value: 18 },
                    { attr: 'wisdom', value: 15 },
                ],
                shootWeeks: 1,
                attributeGrowth: { temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Action, ScriptTheme.Crime, ScriptTheme.Urban],
        heat: 43,
        baseScore: 6.7,
    },
];
